module.exports = __webpack_public_path__ + "img/how-to-play-btn.984666ff.png";